<app-header></app-header> 
<div class="reset_view">
  <spinner [id]="'reset'" [show]='activespinner'></spinner>
  <form (submit)="submit()" [formGroup]="resetForm">
    <div class="form-group row">
      <label for="username"
        class="col-sm-4 col-form-label">User Name<span class="text-star">*</span></label>
      <div class="col-sm-8">
        <input type="text" appAlphabetsWithdot name="username" [(ngModel)]="UserData['username']" formControlName="username" class="form-control" id="username" placeholder="Enter User Name">
        <span style="color:red" [hidden]="validation['username']">Please Enter User Name</span>
      </div>
    </div>
    <div class="form-group row">
      <label for="otp" 
        class="col-sm-4 col-form-label">OTP<span class="text-star">*</span></label>
      <div class="col-sm-8">
        <input type="text" [(ngModel)]="UserData['otp']" appNumbersonly name="otp" formControlName="otp" class="form-control" id="otp" placeholder="Enter OTP">
        <span style="color:red" [hidden]="validation['otp']">Please Enter OTP</span>
      </div>
    </div>
    <div class="form-group row">
      <label for="password"
        class="col-sm-4 col-form-label">New Password<span  data-toggle="tooltip" title="{{passwordtext}}" data-placement="bottom"><i class="fas fa-info-circle"></i></span><span class="text-star">*</span></label>
      <div class="col-sm-8">
        <input type="text" appNotAllowSpaces [(ngModel)]="UserData['password']" (input)="pswdValidate(UserData['password'],'password')" name="password" formControlName="password" class="form-control pw" id="password" placeholder="Enter Password" autocomplete="off">
        <span style="color:red" [hidden]="!showerrorpwd">Weak Password</span>
        <span style="color:red" [hidden]="validation['password']">Please Enter Password</span>
      </div>
    </div>
    <div class="form-group row">
      <label for="confirmpassword"
        class="col-sm-4 col-form-label">Confirm Password<span  data-toggle="tooltip" title="{{passwordtext}}" data-placement="bottom"><i class="fas fa-info-circle"></i></span><span class="text-star">*</span></label>
      <div class="col-sm-8">
        <input type="text" appNotAllowSpaces [(ngModel)]="UserData['confirmpassword']" (input)="pswdValidate(UserData['confirmpassword'],'confirm')" name="confirmpassword" formControlName="confirmpassword" class="form-control pw" id="confirmpassword" placeholder="Enter Confirm Password" autocomplete="off">
        <span style="color:red" [hidden]="!showerrorcnpwd">Weak Password</span>
        <span style="color:red" [hidden]="validation['confirmpassword']">Please Enter Confirm Password</span>
      </div>
    </div>
    <div class="form-group row">
      <label for="confirmpassword"
        class="col-sm-4 col-form-label">Captcha<span class="text-star">*</span></label>
      <div class="col-sm-8 row">
      <!-- <div class="g-recaptcha" data-sitekey="6LcWXcoZAAAAACt-Hco9i5OoLQNMCjbkDP9fZFdO"></div> -->
      <div class="col-sm-6"> <img  id="capthaId" [src]="captchaimage" class="img-fluid" alt="Loading Captha..."/>
      </div>
      <div class="col-sm-4"><input type="text" maxlength=6 id="captcha" [ngModelOptions]="{standalone: true}" name="captcha" [(ngModel)]="UserData['captcha']" style="height:40px;width:200px;" class="captcha-input" autocomplete="off">  <br>
</div>
      <span style="color:red" [hidden]="validation['captcha']">Please Verify Captcha</span>
      </div>
    </div>
    <div class="form-group row">
      <label for="Submit" class="col-sm-4 col-form-label"></label>
      <div class="col-sm-8">
        <input type="submit" class="btn btn-info"  value="Submit">
      </div>
    </div>
    </form>
</div>
<app-footer></app-footer>